import { render, staticRenderFns } from "./modalInfosPrint.vue?vue&type=template&id=b80acff8&"
import script from "./modalInfosPrint.vue?vue&type=script&lang=js&"
export * from "./modalInfosPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports